import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';

const styles = (theme) => {
  const {
    custom: {
      palette: { colorDarkCyan },
    },
    palette: {
      common: { white },
    },
    spacing: { unit },
  } = theme;

  return {
    closeButton: {
      float: 'right',
      marginTop: 4,
      padding: unit,
    },
    closeButtonIcon: {
      color: white,
      fontSize: 16,
    },
    icon: {
      color: white,
      display: 'inline-block',
      float: 'left',
      fontSize: 16,
      position: 'relative',
      top: 12,
    },
    link: {
      cursor: 'pointer',
      fontWeight: 500,
    },
    root: {
      backgroundColor: colorDarkCyan,
      color: white,
      fontWeight: 500,
      lineHeight: '40px',
      padding: `0px ${unit * 2}px`,
      width: '100%',
    },
    text: {
      color: white,
      display: 'inline-block',
      float: 'left',
      height: '100%',
      padding: `0px ${unit}px 0px ${unit * 3 - 4}px`,
    },
  };
};

class ExpiringPasswordAlert extends PureComponent {
  render() {
    const { classes, currentUser, onClose } = this.props;

    return (
      <div className={classes.root}>
        <WarningIcon className={classes.icon} />
        <span className={classes.text}>
          {`Your password will expire ${moment(currentUser.passwordExpiresAt).fromNow()}.`}
          <span className={classes.link} onClick={() => browserHistory.push('/settings/general/account')}>
            {' '}
            Click here{' '}
          </span>
          to update.
        </span>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon className={classes.closeButtonIcon} />
        </IconButton>
      </div>
    );
  }
}

ExpiringPasswordAlert.propTypes = {
  classes: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(ExpiringPasswordAlert);
